import { DotButton, useDotButton } from './EmblaCarouselDotButton';
import {
    PrevButton,
    NextButton,
    usePrevNextButtons,
} from './EmblaCarouselArrowButtons';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const EmblaCarousel = (props) => {
    const { slides } = props;
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
        Autoplay({
            delay: 3000,
            stopOnMouseEnter: true,
            stopOnInteraction: false,
        }),
    ]);

    const { selectedIndex, scrollSnaps, onDotButtonClick } =
        useDotButton(emblaApi);

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
    } = usePrevNextButtons(emblaApi);

    return (
        <section className='embla'>
            <div className='embla__viewport' ref={emblaRef}>
                <div className='embla__container'>
                    {slides.map((slide, index) => (
                        <div className='embla__slide' key={index}>
                            {slide}
                        </div>
                    ))}
                </div>
            </div>

            <div className='embla__controls'>
                <div className='embla__buttons'>
                    <PrevButton
                        onClick={onPrevButtonClick}
                        disabled={prevBtnDisabled}
                    />
                    <NextButton
                        onClick={onNextButtonClick}
                        disabled={nextBtnDisabled}
                    />
                </div>

                <div className='embla__dots'>
                    {scrollSnaps.map((_, index) => (
                        <DotButton
                            key={index}
                            onClick={() => onDotButtonClick(index)}
                            className={'embla__dot'.concat(
                                index === selectedIndex
                                    ? ' embla__dot--selected'
                                    : '',
                            )}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export const EmblaCarouselForReviews = (props) => {
    const { slides, showDotControls = true } = props;
    const [emblaRef, emblaApi] = useEmblaCarousel(
        { align: 'start', loop: true },
        [
            Autoplay({
                delay: 3000,
                stopOnMouseEnter: true,
                stopOnInteraction: false,
            }),
        ],
    );

    const { selectedIndex, scrollSnaps, onDotButtonClick } =
        useDotButton(emblaApi);

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
    } = usePrevNextButtons(emblaApi);

    return (
        <section className='embla embla-multi'>
            <div className='embla__viewport' ref={emblaRef}>
                <div className='embla__container'>
                    {slides.map((slide, index) => (
                        <div className='embla__slide' key={index}>
                            {slide}
                        </div>
                    ))}
                </div>
            </div>

            <div className='embla__controls'>
                <div className='embla__buttons'>
                    <PrevButton
                        onClick={onPrevButtonClick}
                        disabled={prevBtnDisabled}
                    />
                    <NextButton
                        onClick={onNextButtonClick}
                        disabled={nextBtnDisabled}
                    />
                </div>

                {showDotControls && (
                    <div className='embla__dots'>
                        {scrollSnaps.map((_, index) => (
                            <DotButton
                                key={index}
                                onClick={() => onDotButtonClick(index)}
                                className={'embla__dot'.concat(
                                    index === selectedIndex
                                        ? ' embla__dot--selected'
                                        : '',
                                )}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default EmblaCarousel;
